"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserPoolContribution = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var react_1 = require("react");
var web3_1 = __importDefault(require("web3"));
var useUser_1 = require("../../shared/hooks/useUser");
var utils_1 = require("../../shared/utils");
var hooks_1 = require("../../pool/hooks");
var usePriceConverters_1 = require("../../pool/hooks/usePriceConverters");
// Returns in currency, e.g. 50 BNB contributed
function useUserPoolContribution() {
    var account = (0, useUser_1.useUser)().account;
    var _a = (0, hooks_1.usePoolSale)(), saleInstance = _a[1];
    var _b = (0, react_1.useState)(new bn_js_1.default("0")), poolBalance = _b[0], setPoolBalance = _b[1];
    var tokensToCurrency = (0, usePriceConverters_1.usePriceConverters)().tokensToCurrency;
    function update() {
        (0, utils_1.call)(saleInstance, "balanceOf", [account]).then(function (v) {
            return setPoolBalance(web3_1.default.utils.toBN(v));
        });
    }
    (0, react_1.useEffect)(function () {
        if (account && saleInstance) {
            update();
        }
    }, [account, saleInstance]);
    return {
        contributionCurrency: tokensToCurrency(poolBalance),
        poolBalance: poolBalance,
        update: update,
    };
}
exports.useUserPoolContribution = useUserPoolContribution;
